/*
 * This package holds all C5 enumerations extracted from
 * https://www1d.ipbx.at/SIPManagement/restdoc/enum.html
 * and acts as a reference to extend locally used enums
 *
 * This file was auto-generated.
 */
export enum AcdDisplayInternalType {
  NONE = 'NONE',
  QUEUE = 'QUEUE',
  NUMBER = 'NUMBER',
  QUEUE_AND_NUM = 'QUEUE_AND_NUM',
  NUM_TAG = 'NUM_TAG',
  SKILL = 'SKILL',
  QUEUE_AND_NUM_TAG = 'QUEUE_AND_NUM_TAG',
  QUEUE_AND_SKILL = 'QUEUE_AND_SKILL',
}

export enum AcdDisplayOriginatorType {
  NONE = 'NONE',
  NUMBER = 'NUMBER',
  NAME = 'NAME',
}

export enum AcdDistribution {
  PARALLEL = 'PARALLEL',
  SERIAL = 'SERIAL',
  CIRCULAR = 'CIRCULAR',
  LONGEST_IDLE = 'LONGEST_IDLE',
  RANDOM = 'RANDOM',
}

export enum AcdVipRouting {
  NONE = 'NONE',
  A_ROUTING = 'A_ROUTING',
  B_ROUTING = 'B_ROUTING',
  AB_ROUTING = 'AB_ROUTING',
}

export enum AcdAgentRole {
  AGENT = 'AGENT',
  SUPERVISOR = 'SUPERVISOR',
  AGENT_AND_SUPERVISOR = 'AGENT_AND_SUPERVISOR',
}

export enum AcdAgentState {
  LOGGED_IN = 'LOGGED_IN',
  LOGGED_OUT = 'LOGGED_OUT',
  ON_BREAK = 'ON_BREAK',
  WRAP_UP = 'WRAP_UP',
  CUSTOM1 = 'CUSTOM1',
  CUSTOM2 = 'CUSTOM2',
  CUSTOM3 = 'CUSTOM3',
  CUSTOM4 = 'CUSTOM4',
  CUSTOM5 = 'CUSTOM5',
}

export enum AcdAgentEventColumn {
  QUEUE_ID = 'QUEUE_ID',
  USER_ID = 'USER_ID',
  STATE = 'STATE',
  TIME = 'TIME',
}

export enum AcdMetricName {
  RECEIVED_CALLS = 'RECEIVED_CALLS',
  RECEIVED_VIP_CALLS = 'RECEIVED_VIP_CALLS',
  OFFERED_CALLS = 'OFFERED_CALLS',
  OFFERED_VIP_CALLS = 'OFFERED_VIP_CALLS',
  ANSWERED_CALLS = 'ANSWERED_CALLS',
  ANSWERED_VIP_CALLS = 'ANSWERED_VIP_CALLS',
  ABANDONED_CALLS = 'ABANDONED_CALLS',
  ABANDONED_VIP_CALLS = 'ABANDONED_VIP_CALLS',
  TRANSFERRED_CALLS = 'TRANSFERRED_CALLS',
  TRANSFERRED_INCOMING_CALLS = 'TRANSFERRED_INCOMING_CALLS',
  TRANSFERRED_OUTGOING_CALLS = 'TRANSFERRED_OUTGOING_CALLS',
  CALL_OVERFLOW = 'CALL_OVERFLOW',
  NIGHT_MODE_ROUTING = 'NIGHT_MODE_ROUTING',
  FORCE_FORWARD_ROUTING = 'FORCE_FORWARD_ROUTING',
  TIMETABLE_ROUTING = 'TIMETABLE_ROUTING',
  ANSWER_TIME = 'ANSWER_TIME',
  AFTER_CALL_WORK = 'AFTER_CALL_WORK',
  TALK_TIME = 'TALK_TIME',
  HOLD_TIME = 'HOLD_TIME',
  LOGGED_IN_TIME = 'LOGGED_IN_TIME',
  BREAK_TIME = 'BREAK_TIME',
  QUEUE_TIME = 'QUEUE_TIME',
  VIP_QUEUE_TIME = 'VIP_QUEUE_TIME',
  ABANDON_TIME = 'ABANDON_TIME',
  VIP_ABANDON_TIME = 'VIP_ABANDON_TIME',
  QUEUED_CALLS = 'QUEUED_CALLS',
  QUEUED_VIP_CALLS = 'QUEUED_VIP_CALLS',
  LOGGED_IN_AGENTS = 'LOGGED_IN_AGENTS',
  AGENTS_TALKING = 'AGENTS_TALKING',
  AGENTS_ON_BREAK = 'AGENTS_ON_BREAK',
  AGENTS_CUSTOM1 = 'AGENTS_CUSTOM1',
  AGENTS_CUSTOM2 = 'AGENTS_CUSTOM2',
  AGENTS_CUSTOM3 = 'AGENTS_CUSTOM3',
  AGENTS_CUSTOM4 = 'AGENTS_CUSTOM4',
  AGENTS_CUSTOM5 = 'AGENTS_CUSTOM5',
  SL = 'SL',
  SL_80_20 = 'SL_80_20',
  SL_80_30 = 'SL_80_30',
  SL_80_40 = 'SL_80_40',
  HANDLE_TIME = 'HANDLE_TIME',
  OCCUPANCY = 'OCCUPANCY',
  TOTAL_RECEIVED_CALLS = 'TOTAL_RECEIVED_CALLS',
  TOTAL_QUEUED_CALLS = 'TOTAL_QUEUED_CALLS',
  CALL_QUEUE_RATE = 'CALL_QUEUE_RATE',
  TOTAL_OFFERED_CALLS = 'TOTAL_OFFERED_CALLS',
  TOTAL_ANSWERED_CALLS = 'TOTAL_ANSWERED_CALLS',
  EFFICIENCY = 'EFFICIENCY',
  VIP_EFFICIENCY = 'VIP_EFFICIENCY',
  AGENT_EFFICIENCY = 'AGENT_EFFICIENCY',
  AGENT_VIP_EFFICIENCY = 'AGENT_VIP_EFFICIENCY',
  TOTAL_ABANDONED_CALLS = 'TOTAL_ABANDONED_CALLS',
  CALL_ABANDON_RATE = 'CALL_ABANDON_RATE',
  VIP_CALL_ABANDON_RATE = 'VIP_CALL_ABANDON_RATE',
  CALL_OVERFLOW_RATE = 'CALL_OVERFLOW_RATE',
  AGENTS_AVAILABLE = 'AGENTS_AVAILABLE',
  CALLS_ANSWERED_AFTER_TIME = 'CALLS_ANSWERED_AFTER_TIME',
  OUTGOING_CALLS = 'OUTGOING_CALLS',
  OUTGOING_VIP_CALLS = 'OUTGOING_VIP_CALLS',
  TOTAL_OUTGOING_CALLS = 'TOTAL_OUTGOING_CALLS',
  ANSWERED_OUTGOING_CALLS = 'ANSWERED_OUTGOING_CALLS',
  ANSWERED_OUTGOING_VIP_CALLS = 'ANSWERED_OUTGOING_VIP_CALLS',
  TOTAL_ANSWERED_OUTGOING_CALLS = 'TOTAL_ANSWERED_OUTGOING_CALLS',
  ABANDONED_OUTGOING_CALLS = 'ABANDONED_OUTGOING_CALLS',
  ABANDONED_OUTGOING_VIP_CALLS = 'ABANDONED_OUTGOING_VIP_CALLS',
  TOTAL_ABANDONED_OUTGOING_CALLS = 'TOTAL_ABANDONED_OUTGOING_CALLS',
  TALK_TIME_INCOMING = 'TALK_TIME_INCOMING',
  TALK_TIME_OUTGOING = 'TALK_TIME_OUTGOING',
  HOLD_TIME_INCOMING = 'HOLD_TIME_INCOMING',
  HOLD_TIME_OUTGOING = 'HOLD_TIME_OUTGOING',
  AGENTS_TALKING_INCOMING = 'AGENTS_TALKING_INCOMING',
  AGENTS_TALKING_OUTGOING = 'AGENTS_TALKING_OUTGOING',
  AFTER_CALL_WORK_INCOMING = 'AFTER_CALL_WORK_INCOMING',
  AFTER_CALL_WORK_OUTGOING = 'AFTER_CALL_WORK_OUTGOING',
}

export enum AcdMetricPart {
  MIN = 'MIN',
  MAX = 'MAX',
  AVG = 'AVG',
  SUM = 'SUM',
  COUNT = 'COUNT',
  CURRENT = 'CURRENT',
  VAL = 'VAL',
}

export enum AcdMonitoringConfigGroupBy {
  QUEUE = 'QUEUE',
  AGENT = 'AGENT',
  STATE = 'STATE',
}

export enum AcdReportExportFormat {
  CSV = 'CSV',
  EXCEL = 'EXCEL',
  PDF = 'PDF',
}

export enum AcdReportLayout {
  TABLE = 'TABLE',
  TABLE_TRANSPOSED = 'TABLE_TRANSPOSED',
  LINE_CHART = 'LINE_CHART',
}

export enum AcdReportMetaColumn {
  QUEUE_ID = 'QUEUE_ID',
  QUEUE_NAME = 'QUEUE_NAME',
  AGENT_ID = 'AGENT_ID',
  AGENT_FIRST_NAME = 'AGENT_FIRST_NAME',
  AGENT_LAST_NAME = 'AGENT_LAST_NAME',
  AGENT_BUSINESS_NUM = 'AGENT_BUSINESS_NUM',
}

export enum AcdReportPageLayout {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
}

export enum AcdReportPageSize {
  A4 = 'A4',
  A3 = 'A3',
  LETTER = 'LETTER',
}

export enum AcdReportPeriod {
  CURRENT_HOUR = 'CURRENT_HOUR',
  CURRENT_DAY = 'CURRENT_DAY',
  CURRENT_WEEK = 'CURRENT_WEEK',
  CURRENT_MONTH = 'CURRENT_MONTH',
  CURRENT_QUARTER = 'CURRENT_QUARTER',
  CURRENT_YEAR = 'CURRENT_YEAR',
  PREVIOUS_HOUR = 'PREVIOUS_HOUR',
  PREVIOUS_DAY = 'PREVIOUS_DAY',
  PREVIOUS_WEEK = 'PREVIOUS_WEEK',
  PREVIOUS_MONTH = 'PREVIOUS_MONTH',
  PREVIOUS_QUARTER = 'PREVIOUS_QUARTER',
  PREVIOUS_YEAR = 'PREVIOUS_YEAR',
}

export enum AcdReportSchedule {
  DAYLY = 'DAYLY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum AcdReportSubPeriod {
  QUARTER_HOUR = 'QUARTER_HOUR',
  HALF_HOUR = 'HALF_HOUR',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
}

export enum AcdReportType {
  AGENT_KPI = 'AGENT_KPI',
  AGENT_DETAIL_KPI = 'AGENT_DETAIL_KPI',
  CALL_HISTORY = 'CALL_HISTORY',
  QUEUE_KPI = 'QUEUE_KPI',
  QUEUE_DETAIL_KPI = 'QUEUE_DETAIL_KPI',
  AGENT_ACTIVITY = 'AGENT_ACTIVITY',
}

export enum AcdRouteConfigAction {
  NUMBER = 'NUMBER',
  ANNC = 'ANNC',
  VOICE_MAIL = 'VOICE_MAIL',
  RELEASE = 'RELEASE',
}

export enum AcdRouteConfigRouteType {
  FORWARD_ALL = 'FORWARD_ALL',
  QUEUE_FULL = 'QUEUE_FULL',
  NO_AGENT_LOGGED_IN = 'NO_AGENT_LOGGED_IN',
  MAX_QUEUE_WAIT_TIME = 'MAX_QUEUE_WAIT_TIME',
  NIGHT_MODE = 'NIGHT_MODE',
  MAX_RING_TIME = 'MAX_RING_TIME',
}

export enum AcdSkillMode {
  EXACT = 'EXACT',
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}

export enum AcdTargetType {
  QUEUE = 'QUEUE',
  AGENT = 'AGENT',
}

export enum AcdCallLogColumn {
  CALL_ID = 'CALL_ID',
  QUEUE_ID = 'QUEUE_ID',
  USER_ID = 'USER_ID',
  STATE = 'STATE',
  PRIORITY = 'PRIORITY',
  STARTED_AT = 'STARTED_AT',
  ANSWERED_AT = 'ANSWERED_AT',
  RELEASED_AT = 'RELEASED_AT',
  RELEASE_CAUSE = 'RELEASE_CAUSE',
  CALLING_NUM = 'CALLING_NUM',
  CALLED_NUM = 'CALLED_NUM',
  TRANSFER_NUM = 'TRANSFER_NUM',
  AFTER_CALL_WORK = 'AFTER_CALL_WORK',
  QUEUE_TIME = 'QUEUE_TIME',
  TALK_TIME = 'TALK_TIME',
  HOLD_TIME = 'HOLD_TIME',
  DIRECTION = 'DIRECTION',
}

export enum AcdCallLogState {
  QUEUED = 'QUEUED',
  OFFERED = 'OFFERED',
  ANSWERED = 'ANSWERED',
  HELD = 'HELD',
  RETRIEVED = 'RETRIEVED',
  TRANSFERRED = 'TRANSFERRED',
  RELEASED = 'RELEASED',
  ABANDONED = 'ABANDONED',
  OVERFLOW = 'OVERFLOW',
  INITIATED = 'INITIATED',
}

export enum AclBarringType {
  NOT_SET = 'NOT_SET',
  FORBIDDEN = 'FORBIDDEN',
  BUSY = 'BUSY',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  DIVERSION = 'DIVERSION',
  RESPONSE_CODE = 'RESPONSE_CODE',
}

export enum AclDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}

export enum AclEntryAclAccessType {
  DENY = 'DENY',
  ALLOW = 'ALLOW',
}

export enum AclEntryInputFormat {
  SIMPLE_FORMAT = 'SIMPLE_FORMAT',
  REGULAR_EXPRESSION = 'REGULAR_EXPRESSION',
}

export enum AclEntryScope {
  CALL = 'CALL',
  CALL_FORWARDING = 'CALL_FORWARDING',
}

export enum Activity {
  UNKNOWN = 'UNKNOWN',
  ONLINE = 'ONLINE',
  HOME_OFFICE = 'HOME_OFFICE',
  AWAY = 'AWAY',
  OUT_OF_OFFICE = 'OUT_OF_OFFICE',
  LUNCH = 'LUNCH',
  DND = 'DND',
  MEETING = 'MEETING',
  ILLNESS = 'ILLNESS',
  VACATION = 'VACATION',
  RESERVED1 = 'RESERVED1',
  RESERVED2 = 'RESERVED2',
  RESERVED3 = 'RESERVED3',
  RESERVED4 = 'RESERVED4',
  RESERVED5 = 'RESERVED5',
  RESERVED6 = 'RESERVED6',
  RESERVED7 = 'RESERVED7',
  RESERVED8 = 'RESERVED8',
  RESERVED9 = 'RESERVED9',
  RESERVED10 = 'RESERVED10',
  CUSTOM1 = 'CUSTOM1',
  CUSTOM2 = 'CUSTOM2',
  CUSTOM3 = 'CUSTOM3',
  CUSTOM4 = 'CUSTOM4',
  CUSTOM5 = 'CUSTOM5',
  CUSTOM6 = 'CUSTOM6',
  CUSTOM7 = 'CUSTOM7',
  CUSTOM8 = 'CUSTOM8',
  CUSTOM9 = 'CUSTOM9',
  CUSTOM10 = 'CUSTOM10',
}

export enum AddressBookBookType {
  PRIVATE = 'PRIVATE',
  ENTERPRISE = 'ENTERPRISE',
  CORPORATE = 'CORPORATE',
  GROUP = 'GROUP',
  SYSTEM = 'SYSTEM',
  CALL_CENTER = 'CALL_CENTER',
  ALL = 'ALL',
}

export enum AddressBookEntry {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  JOB_TITLE = 'JOB_TITLE',
  COMPANY = 'COMPANY',
  DEPARTMENT = 'DEPARTMENT',
  OFFICE = 'OFFICE',
  ADDRESS = 'ADDRESS',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  ZIP_CODE = 'ZIP_CODE',
  EMAIL = 'EMAIL',
  EMAIL2 = 'EMAIL2',
  EMAIL3 = 'EMAIL3',
  BUSINESS_PHONE = 'BUSINESS_PHONE',
  HOME_PHONE = 'HOME_PHONE',
  MOBILE_PHONE = 'MOBILE_PHONE',
  BUSINESS_PHONE2 = 'BUSINESS_PHONE2',
  HOME_PHONE2 = 'HOME_PHONE2',
  MOBILE_PHONE2 = 'MOBILE_PHONE2',
  FAX = 'FAX',
  HOME_FAX = 'HOME_FAX',
  BUSINESS_FAX = 'BUSINESS_FAX',
  IP_PHONE = 'IP_PHONE',
  ALL = 'ALL',
}

export enum AddressBookFavNum {
  BUSINESS = 'BUSINESS',
  SECOND_BUSINESS = 'SECOND_BUSINESS',
  HOME = 'HOME',
  SECOND_HOME = 'SECOND_HOME',
  MOBILE = 'MOBILE',
  SECOND_MOBILE = 'SECOND_MOBILE',
  EXTENSION = 'EXTENSION',
}

export enum AddressBookGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum AddressBookPictureType {
  JPEG = 'JPEG',
  GIF = 'GIF',
  PNG = 'PNG',
}

export enum AnnouncementAnnouncementType {
  DOMAIN = 'DOMAIN',
  EARLY_MEDIA = 'EARLY_MEDIA',
  MUSIC_ON_HOLD = 'MUSIC_ON_HOLD',
  PARK_SERVER = 'PARK_SERVER',
  BLACK_WHITE_LIST = 'BLACK_WHITE_LIST',
  ACD = 'ACD',
  DEDICATED_CONFERENCE = 'DEDICATED_CONFERENCE',
  ADHOC_CONFERENCE = 'ADHOC_CONFERENCE',
  CALL_RECORDING = 'CALL_RECORDING',
}

export enum AnnouncementFileName {
  DEDICATED_ASK_FOR_PIN_ID = 'DEDICATED_ASK_FOR_PIN_ID',
  DEDICATED_END_CALL_ID = 'DEDICATED_END_CALL_ID',
  DEDICATED_END_CONF_ID = 'DEDICATED_END_CONF_ID',
  DEDICATED_ESTABLISH_CONNECTION_ID = 'DEDICATED_ESTABLISH_CONNECTION_ID',
  DEDICATED_GREETING_ID = 'DEDICATED_GREETING_ID',
  DEDICATED_LOGIN_CORRECT_ID = 'DEDICATED_LOGIN_CORRECT_ID',
  DEDICATED_LOGIN_NOT_CORRECT_ID = 'DEDICATED_LOGIN_NOT_CORRECT_ID',
  DEDICATED_MUSIC_ID = 'DEDICATED_MUSIC_ID',
  DEDICATED_NO_ADMIN_ID = 'DEDICATED_NO_ADMIN_ID',
  DEDICATED_NO_ADMIN_WAITING_LOOP_ID = 'DEDICATED_NO_ADMIN_WAITING_LOOP_ID',
  DEDICATED_NO_RESOURCES_ID = 'DEDICATED_NO_RESOURCES_ID',
  DEDICATED_SILENCE_ID = 'DEDICATED_SILENCE_ID',
  DEDICATED_SINGLE_USER_WAITING_LOOP_ID = 'DEDICATED_SINGLE_USER_WAITING_LOOP_ID',
  DEDICATED_TOO_MANY_USERS_ID = 'DEDICATED_TOO_MANY_USERS_ID',
  DEDICATED_TRY_LATER_ID = 'DEDICATED_TRY_LATER_ID',
  DEDICATED_RECORD_NAME_ID = 'DEDICATED_RECORD_NAME_ID',
  DEDICATED_JOINED_ID = 'DEDICATED_JOINED_ID',
  ADHOC_END_ID = 'ADHOC_END_ID',
  ADHOC_FIRSTPARTICIPANT_ID = 'ADHOC_FIRSTPARTICIPANT_ID',
  ADHOC_ONHOLD_ID = 'ADHOC_ONHOLD_ID',
  VOICE_RECORDING_INCOMING_PCR_ID = 'VOICE_RECORDING_INCOMING_PCR_ID',
  VOICE_RECORDING_START_ADHOC_ID = 'VOICE_RECORDING_START_ADHOC_ID',
  VOICE_RECORDING_FORBIDDEN_ID = 'VOICE_RECORDING_FORBIDDEN_ID',
  VOICE_RECORDING_BOX_FULL_ID = 'VOICE_RECORDING_BOX_FULL_ID',
}

export enum CalendarWeekRule {
  DIN_ISO = 'DIN_ISO',
  USA = 'USA',
}

export enum CallLogCallDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}

export enum CallLogCallType {
  VOICE = 'VOICE',
  FAX = 'FAX',
  VOICE_MAIL = 'VOICE_MAIL',
  RECORDING = 'RECORDING',
}

export enum CampOnBusyNotify {
  ALWAYS = 'ALWAYS',
  ONLY_EXTERNAL = 'ONLY_EXTERNAL',
  ONLY_INTERNAL = 'ONLY_INTERNAL',
  NEVER = 'NEVER',
}

export enum ClientApp {
  DESKTOP_CONTROL = 'DESKTOP_CONTROL',
  DESKTOP_OPERATOR = 'DESKTOP_OPERATOR',
  MOBILE_CONTROL = 'MOBILE_CONTROL',
  WEB_CONTROL = 'WEB_CONTROL',
  WEB_MEET = 'WEB_MEET',
}

export enum ConferenceConfType {
  NONE = 'NONE',
  AD_HOC = 'AD_HOC',
  DIAL_IN = 'DIAL_IN',
  DIAL_OUT = 'DIAL_OUT',
  RECORD = 'RECORD',
  DEDICATED = 'DEDICATED',
}

export enum ConferenceVideoMode {
  NONE = 'NONE',
  VOICE_ACTIVATED_SWITCHING = 'VOICE_ACTIVATED_SWITCHING',
  CONTINUOUS_PRESENCE = 'CONTINUOUS_PRESENCE',
}

export enum ConferenceWaitingLoopMode {
  VOICE = 'VOICE',
  MUSIC = 'MUSIC',
  SILENCE = 'SILENCE',
}

export enum ContactContactType {
  NORMAL = 'NORMAL',
  BREAKOUT = 'BREAKOUT',
}

export enum CstaAuth {
  NONE = 'NONE',
  LOCAL = 'LOCAL',
  DB = 'DB',
}

export enum CstaClientType {
  OCS = 'OCS',
  CSTA_CONVERTER = 'CSTA_CONVERTER',
  OTHER = 'OTHER',
}

export enum CstaIpRestriction {
  VIA_FIRST = 'VIA_FIRST',
  VIA_LAST = 'VIA_LAST',
  VIA_ANY = 'VIA_ANY',
}

export enum CstaPermission {
  OWN = 'OWN',
  DOMAIN = 'DOMAIN',
  ANY = 'ANY',
  CUSTOM = 'CUSTOM',
}

export enum CstaRoutingLogic {
  USE_RECORD_ROUTE = 'USE_RECORD_ROUTE',
  USE_VIA = 'USE_VIA',
}

export enum DeviceDevType {
  PHONE = 'PHONE',
  SERVICE = 'SERVICE',
  BUSINESS_TRUNK = 'BUSINESS_TRUNK',
}

export enum DevicePhoneType {
  UNKNOWN = 'UNKNOWN',
  MOBILE_OFFICE = 'MOBILE_OFFICE',
  MOBILE_CONTROL = 'MOBILE_CONTROL',
  DESKTOP_CONTROL = 'DESKTOP_CONTROL',
  DESKTOP_OPERATOR = 'DESKTOP_OPERATOR',
}

export enum DeviceServiceType {
  UNKNOWN = 'UNKNOWN',
  INDICATOR = 'INDICATOR',
  FAX = 'FAX',
  VOICE_MAIL = 'VOICE_MAIL',
  DEDICATED_CONF = 'DEDICATED_CONF',
  AD_HOC_CONF = 'AD_HOC_CONF',
  IVR = 'IVR',
  CALL_REC = 'CALL_REC',
  PARK_SERV = 'PARK_SERV',
  MOBILE_OFFICE = 'MOBILE_OFFICE',
  MOBILE_CONTROL = 'MOBILE_CONTROL',
  DESKTOP_CONTROL = 'DESKTOP_CONTROL',
  DESKTOP_OPERATOR = 'DESKTOP_OPERATOR',
  PREPARATION_MOBILE_SERVICE = 'PREPARATION_MOBILE_SERVICE',
  TABLET = 'TABLET',
  UC_COLLABORATION_OWNER = 'UC_COLLABORATION_OWNER',
  UC_COLLABORATION_GUEST = 'UC_COLLABORATION_GUEST',
  MOBILE_COMMUNICATOR_WITHOUT_GSM = 'MOBILE_COMMUNICATOR_WITHOUT_GSM',
}

export enum DeviceAttrSpecAttrType {
  NORMAL = 'NORMAL',
  VALUE = 'VALUE',
  TYPE = 'TYPE',
  LABEL = 'LABEL',
  BLF_AUDIBLE = 'BLF_AUDIBLE',
  BLF_POPUP = 'BLF_POPUP',
  GUI_FKEY = 'GUI_FKEY',
  DK_TYPE = 'DK_TYPE',
  PICKUP_VALUE = 'PICKUP_VALUE',
  LINE = 'LINE',
}

export enum DeviceSettingOverwrite {
  ALLOW_OVERWRITE_READ_WRITE = 'ALLOW_OVERWRITE_READ_WRITE',
  ALLOW_OVERWRITE_READ_ONLY = 'ALLOW_OVERWRITE_READ_ONLY',
  DENY_OVERWRITE_READ_ONLY = 'DENY_OVERWRITE_READ_ONLY',
  DENY_OVERWRITE_READ_WRITE = 'DENY_OVERWRITE_READ_WRITE',
}

export enum DomainCallCompletionActType {
  IVR = 'IVR',
  FEATURE_CODE = 'FEATURE_CODE',
  SITE = 'SITE',
}

export enum DomainDisplayNameOrder {
  FIRSTNAME_LASTNAME = 'FIRSTNAME_LASTNAME',
  LASTNAME = 'LASTNAME',
  LASTNAME_FIRSTNAME = 'LASTNAME_FIRSTNAME',
}

export enum DomainDomainType {
  UNKNOWN = 'UNKNOWN',
  IPBX = 'IPBX',
  RESIDENTIAL = 'RESIDENTIAL',
  ROUTING = 'ROUTING',
  MPBX = 'MPBX',
  MIXED = 'MIXED',
}

export enum DomainEncryptionMode {
  STARTTLS = 'STARTTLS',
  SSL = 'SSL',
}

export enum DomainErrorRespMode {
  CODE = 'CODE',
  TONE = 'TONE',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
}

export enum DomainFaxMode {
  DOMAIN = 'DOMAIN',
  USER = 'USER',
}

export enum DomainFaxNumMode {
  EXTENSION = 'EXTENSION',
  E164 = 'E164',
}

export enum DomainForceGateway {
  NONE = 'NONE',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  ENTERPRISE = 'ENTERPRISE',
  SITE = 'SITE',
}

export enum DomainForwardingExternalDisplay {
  ORIGINATOR = 'ORIGINATOR',
  FORWARDER = 'FORWARDER',
}

export enum DomainForwardingInternalDisplay {
  ORIG_NAME_NO_FWD = 'ORIG_NAME_NO_FWD',
  ORIG_NUM_FWD_NUM = 'ORIG_NUM_FWD_NUM',
  ORIG_NUM_FWD_NAME = 'ORIG_NUM_FWD_NAME',
  ORIG_NUM_NO_FWD = 'ORIG_NUM_NO_FWD',
  ORIG_NAME_FWD_NUM = 'ORIG_NAME_FWD_NUM',
  ORIG_NAME_FWD_NAME = 'ORIG_NAME_FWD_NAME',
  NO_ORIG_FWD_NUM = 'NO_ORIG_FWD_NUM',
  NO_ORIG_FWD_NAME = 'NO_ORIG_FWD_NAME',
}

export enum DomainLevel {
  SYSTEM = 'SYSTEM',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  ENTERPRISE = 'ENTERPRISE',
  SITE = 'SITE',
  GROUP = 'GROUP',
  USER = 'USER',
  GATEWAY = 'GATEWAY',
  NUMBER_RANGE = 'NUMBER_RANGE',
  CALL_CENTER = 'CALL_CENTER',
}

export enum DomainNightModeStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  ACTIVE_MANUAL = 'ACTIVE_MANUAL',
  INACTIVE_MANUAL = 'INACTIVE_MANUAL',
}

export enum DomainNormalization {
  NONE = 'NONE',
  NATIONAL = 'NATIONAL',
  INTERNATIONAL = 'INTERNATIONAL',
  LOCAL = 'LOCAL',
}

export enum DomainNumPresentation {
  DEFAULT = 'DEFAULT',
  ORIGINATOR = 'ORIGINATOR',
  FORWARDER = 'FORWARDER',
}

export enum EnhancedActivity {
  NONE = 'NONE',
  IN_A_CALL = 'IN_A_CALL',
  PRESENTING = 'PRESENTING',
  IN_A_CONFERENCE_CALL = 'IN_A_CONFERENCE_CALL',
}

export enum featureAdviceOfChargeType {
  AOC_D = 'AOC_D',
  AOC_E = 'AOC_E',
  AOC_P = 'AOC_P',
  AOC_99 = 'AOC_99',
}

export enum FeatureAssistantState {
  INACTIVE = 'INACTIVE',
  RINGING = 'RINGING',
  NOTIFY = 'NOTIFY',
}

export enum featureCallRecordingDir {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
  ALL = 'ALL',
}

export enum featureCallRecordingMode {
  AD_HOC = 'AD_HOC',
  PERMANENT = 'PERMANENT',
}

export enum FeatureCqAgentState {
  LOGGED_OUT = 'LOGGED_OUT',
  LOGGED_IN = 'LOGGED_IN',
}

export enum FeatureCqQueueType {
  PARALLEL = 'PARALLEL',
  SERIAL = 'SERIAL',
  RANDOM = 'RANDOM',
  LONGEST_IDLE = 'LONGEST_IDLE',
}

export enum FeatureDdiDestNumFormat {
  INTERNATIONAL = 'INTERNATIONAL',
  ACCESS_CODE = 'ACCESS_CODE',
}

export enum featureDirectDialingInAddressPrefix {
  INTERNATIONAL = 'INTERNATIONAL',
  E164 = 'E164',
  NONE = 'NONE',
  NO_CHANGE = 'NO_CHANGE',
  NATIONAL = 'NATIONAL',
  SUBSCRIBER = 'SUBSCRIBER',
}

export enum featureDirectDialingInDisplayName {
  NO = 'NO',
  YES = 'YES',
  NUMBER_ONLY = 'NUMBER_ONLY',
  FROM_USER_PART = 'FROM_USER_PART',
}

export enum FeatureFeatCondition {
  ALWAYS = 'ALWAYS',
  EXTERNAL = 'EXTERNAL',
}

export enum FeatureFeatMode {
  CLIENT = 'CLIENT',
  USER = 'USER',
}

export enum FeatureFeatName {
  AD_HOC_CONFERENCING = 'AD_HOC_CONFERENCING',
  PARK_CALL = 'PARK_CALL',
  PICKUP_CALL = 'PICKUP_CALL',
  CALL_BACK_NUMBER = 'CALL_BACK_NUMBER',
  CALL_COMPLETION_BUSY_SUBSCRIBER = 'CALL_COMPLETION_BUSY_SUBSCRIBER',
  CALL_COMPLETION_NOT_REACHABLE = 'CALL_COMPLETION_NOT_REACHABLE',
  CALL_FORWARD_BUSY = 'CALL_FORWARD_BUSY',
  CALL_FORWARD_NOT_REACHABLE = 'CALL_FORWARD_NOT_REACHABLE',
  CALL_FORWARD_SELECTIVE = 'CALL_FORWARD_SELECTIVE',
  CALL_FORWARD_TIMEOUT = 'CALL_FORWARD_TIMEOUT',
  CALL_FORWARD_UNCONDITIONAL = 'CALL_FORWARD_UNCONDITIONAL',
  CALL_FORWARD_UNREGISTERED = 'CALL_FORWARD_UNREGISTERED',
  CALLING_LINE_IDENTIFICATION_RESTRICTION = 'CALLING_LINE_IDENTIFICATION_RESTRICTION',
  CALLING_LINE_IDENTIFICATION_PRESENTATION_OVERRIDE = 'CALLING_LINE_IDENTIFICATION_PRESENTATION_OVERRIDE',
  CALLING_LINE_IDENTIFICATION_PRESENTATION_NO_SCREENING = 'CALLING_LINE_IDENTIFICATION_PRESENTATION_NO_SCREENING',
  CONNECTED_LINE_IDENTIFICATION_PRESENTATION = 'CONNECTED_LINE_IDENTIFICATION_PRESENTATION',
  CONNECTED_LINE_IDENTIFICATION_RESTRICTION = 'CONNECTED_LINE_IDENTIFICATION_RESTRICTION',
  CONNECTED_LINE_IDENTIFICATION_PRESENTATION_NO_SCREENING = 'CONNECTED_LINE_IDENTIFICATION_PRESENTATION_NO_SCREENING',
  CALL_QUEUE = 'CALL_QUEUE',
  CSTA_THIRD_PARTY_CALL_CONTROL = 'CSTA_THIRD_PARTY_CALL_CONTROL',
  SOFT_CLIENT_CTI = 'SOFT_CLIENT_CTI',
  DIRECT_DIAL_IN = 'DIRECT_DIAL_IN',
  EARLY_MEDIA = 'EARLY_MEDIA',
  FAX_MAIL = 'FAX_MAIL',
  MANAGEMENT_ASSISTANT_SERVICE = 'MANAGEMENT_ASSISTANT_SERVICE',
  MALICIOUS_CALL_IDENTIFICATION = 'MALICIOUS_CALL_IDENTIFICATION',
  MUSIC_ON_HOLD = 'MUSIC_ON_HOLD',
  PHONE_BOOK_LOOKUP = 'PHONE_BOOK_LOOKUP',
  PICKUP_CALL_QUEUE = 'PICKUP_CALL_QUEUE',
  PRESENCE = 'PRESENCE',
  PARALLEL_RINGING = 'PARALLEL_RINGING',
  FORWARDED_CALL_REJECTION = 'FORWARDED_CALL_REJECTION',
  SOFT_CLIENT_SCO = 'SOFT_CLIENT_SCO',
  SOFT_CLIENT_SOFT_PHONE = 'SOFT_CLIENT_SOFT_PHONE',
  MOBILE_OFFICE = 'MOBILE_OFFICE',
  MOBILE_VOIP = 'MOBILE_VOIP',
  MOBILE_CONTROL = 'MOBILE_CONTROL',
  DESKTOP_CONTROL = 'DESKTOP_CONTROL',
  TWIN_NUMBER = 'TWIN_NUMBER',
  SERVICE_NUMBER = 'SERVICE_NUMBER',
  VOICE_MAIL = 'VOICE_MAIL',
  VOICE_RECORDING = 'VOICE_RECORDING',
  CALL_COMPLETION_ACTIVATING_DEACTIVATING = 'CALL_COMPLETION_ACTIVATING_DEACTIVATING',
  CALL_FORWARDING_ALL = 'CALL_FORWARDING_ALL',
  CALL_TRANSFER = 'CALL_TRANSFER',
  FAX_PRINTER = 'FAX_PRINTER',
  CALL_HOLD = 'CALL_HOLD',
  CALL_WAITING = 'CALL_WAITING',
  OUTGOING_CALLING_IDENTITY = 'OUTGOING_CALLING_IDENTITY',
  LOCK_CODE = 'LOCK_CODE',
  MOBILE_LINK = 'MOBILE_LINK',
  CENTRAL_DND = 'CENTRAL_DND',
  NIGHT_MODE = 'NIGHT_MODE',
  MAS_LOGIN = 'MAS_LOGIN',
  DESKTOP_OPERATOR = 'DESKTOP_OPERATOR',
  MULTI_SIM = 'MULTI_SIM',
  CALL_FORWARD_BUSINESS_NUMBER = 'CALL_FORWARD_BUSINESS_NUMBER',
  SINGLE_NUMBER_REACH = 'SINGLE_NUMBER_REACH',
  RICH_PRESENCE = 'RICH_PRESENCE',
  ADVICE_OF_CHARGE = 'ADVICE_OF_CHARGE',
  ACD_QUEUE_LOGIN = 'ACD_QUEUE_LOGIN',
  ACD_QUEUE_BREAK = 'ACD_QUEUE_BREAK',
  ACD_QUEUE_WRAP_UP = 'ACD_QUEUE_WRAP_UP',
  ACD_FORCE_CFW = 'ACD_FORCE_CFW',
  TABLET = 'TABLET',
  ANONYMOUS_CALL_REJECTION = 'ANONYMOUS_CALL_REJECTION',
  UC_INSTANT_MESSAGING = 'UC_INSTANT_MESSAGING',
  UC_SMARTPHONE = 'UC_SMARTPHONE',
  UC_VIDEO = 'UC_VIDEO',
  UC_COLLABORATION = 'UC_COLLABORATION',
}

export enum FeatureFeatYesOrNo {
  YES = 'YES',
  NO = 'NO',
}

export enum FeatureMcidActType {
  PERMANENT = 'PERMANENT',
  FEATURE_CODE = 'FEATURE_CODE',
}

export enum FeatureOciExternalFormat {
  TRUNK_NUMBER = 'TRUNK_NUMBER',
  COMPLETE_NUMBER = 'COMPLETE_NUMBER',
}

export enum FeatureStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export enum FeatureStorageFormat {
  UMS_BOX = 'UMS_BOX',
  EXTERNAL_RECORDING_SERVER = 'EXTERNAL_RECORDING_SERVER',
}

export enum FeatureWhiteListEntryState {
  SHOW_NUMBER = 'SHOW_NUMBER',
  NOTIFY = 'NOTIFY',
}

export enum FeatureCodeActDeactType {
  NONE = 'NONE',
  DEFAULT = 'DEFAULT',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
}

export enum FeatureDataFeatType {
  UNKNOWN = 'UNKNOWN',
  USER = 'USER',
  GROUP = 'GROUP',
  GATEWAY = 'GATEWAY',
  VIRTUAL = 'VIRTUAL',
}

export enum FuncKeyAction {
  NONE = 'NONE',
  LINE = 'LINE',
  SPEED_DIAL = 'SPEED_DIAL',
  EXTENSION = 'EXTENSION',
  BLF = 'BLF',
  PHONE_BOOK = 'PHONE_BOOK',
  PHONE_LOCK_ON = 'PHONE_LOCK_ON',
  PHONE_LOCK_OFF = 'PHONE_LOCK_OFF',
  PARK = 'PARK',
  CLIR_ON = 'CLIR_ON',
  CLIR_OFF = 'CLIR_OFF',
  PICKUP = 'PICKUP',
  CENTRAL_DND_ON = 'CENTRAL_DND_ON',
  CENTRAL_DND_OFF = 'CENTRAL_DND_OFF',
  FCR_ON = 'FCR_ON',
  FCR_OFF = 'FCR_OFF',
  NIGHT_MODE_ON = 'NIGHT_MODE_ON',
  NIGHT_MODE_OFF = 'NIGHT_MODE_OFF',
  REPERTORY_DIAL = 'REPERTORY_DIAL',
  SERVER_FEAT = 'SERVER_FEAT',
  HOLD = 'HOLD',
  CONSULT_AND_TRANSFER = 'CONSULT_AND_TRANSFER',
  ALTERNATE = 'ALTERNATE',
  CONFERENCE = 'CONFERENCE',
  DND = 'DND',
  BLIND_TRANSFER = 'BLIND_TRANSFER',
  CALL_DEFLECTION = 'CALL_DEFLECTION',
  SHIFT = 'SHIFT',
  AICS_ZIP_TONE = 'AICS_ZIP_TONE',
  CALLBACK = 'CALLBACK',
  CANCEL_CALLBACK = 'CANCEL_CALLBACK',
  JOIN = 'JOIN',
  HEADSET = 'HEADSET',
  GROUP_PICKUP = 'GROUP_PICKUP',
  REPEAT_DIALING = 'REPEAT_DIALING',
  RINGER_OFF = 'RINGER_OFF',
  VOICE_REC = 'VOICE_REC',
  CORPORATE_PHONE_BOOK = 'CORPORATE_PHONE_BOOK',
  ACCEPTED = 'ACCEPTED',
  CALL_LIST = 'CALL_LIST',
  CHANGE_ACTIVE_IDENTITY = 'CHANGE_ACTIVE_IDENTITY',
  CLEAR_PICKUP_INFO = 'CLEAR_PICKUP_INFO',
  CONTACT = 'CONTACT',
  DIR = 'DIR',
  FAVORITES = 'FAVORITES',
  FORWARD_ALL = 'FORWARD_ALL',
  HELP = 'HELP',
  LDAP_DIR = 'LDAP_DIR',
  MENU = 'MENU',
  MISSED = 'MISSED',
  MONITOR = 'MONITOR',
  MUTE = 'MUTE',
  PRESENCE = 'PRESENCE',
  NEXT_IDENTITY = 'NEXT_IDENTITY',
  PREV_IDENTITY = 'PREV_IDENTITY',
  RETRIEVE_VM = 'RETRIEVE_VM',
  VIRTUAL = 'VIRTUAL',
  RETRIEVE_CALL = 'RETRIEVE_CALL',
  HOTELING = 'HOTELING',
  ACD = 'ACD',
  WRAP_UP = 'WRAP_UP',
  ONE_TOUCH = 'ONE_TOUCH',
  LINE_STATUS = 'LINE_STATUS',
  PARALLEL_RINGING = 'PARALLEL_RINGING',
  SHARED_LINE = 'SHARED_LINE',
  INTERCOM = 'INTERCOM',
  MULTICAST_PAGING = 'MULTICAST_PAGING',
  SPEED_DIAL_VIA_ACCOUNT = 'SPEED_DIAL_VIA_ACCOUNT',
  DIAL_DTMF = 'DIAL_DTMF',
  EVENT_LIST = 'EVENT_LIST',
  MONITORED_CALL_PARK = 'MONITORED_CALL_PARK',
  PREFIX = 'PREFIX',
}

export enum GatewayGatewayType {
  CENTRAL = 'CENTRAL',
  LOCAL_BREAKOUT = 'LOCAL_BREAKOUT',
  UC = 'UC',
}

export enum GroupGroupType {
  ROUTING = 'ROUTING',
  FEATURE = 'FEATURE',
  LOCATION = 'LOCATION',
  PICKUP = 'PICKUP',
  CQ_PICKUP = 'CQ_PICKUP',
  USER_FAVORITE = 'USER_FAVORITE',
}

export enum IpFilterAccessRule {
  ALLOW = 'ALLOW',
  DENY = 'DENY',
}

export enum IpFilterProtocol {
  ANY = 'ANY',
  UDP = 'UDP',
  TCP = 'TCP',
  TLS = 'TLS',
}

export enum IpFilterScope {
  VOIP = 'VOIP',
  SETTING = 'SETTING',
  ANY = 'ANY',
}

export enum IvrActionIvrFeatAction {
  NONE = 'NONE',
  RELEASE = 'RELEASE',
  PREVIOUS_BLOCK = 'PREVIOUS_BLOCK',
}

export enum IvrActionIvrTarget {
  UNKNOWN = 'UNKNOWN',
  FEATURE = 'FEATURE',
  BLOCK = 'BLOCK',
  SIP = 'SIP',
  QUEUE = 'QUEUE',
}

export enum LdapConfigLdapProtocol {
  LDAP = 'LDAP',
  LDAPS = 'LDAPS',
}

export enum LdapConfigLdapServer {
  CUSTOM = 'CUSTOM',
  C5 = 'C5',
  THIRD_PARTY = 'THIRD_PARTY',
}

export enum LogLevel {
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  INFO = 'INFO',
  OFF = 'OFF',
  WARN = 'WARN',
}

export enum MemberRole {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  USER = 'USER',
}

export enum MeetingType {
  ADHOC = 'ADHOC',
  MY_ROOM = 'MY_ROOM',
  TEAM = 'TEAM',
}

export enum msbrPlaceholderType {
  VOIP = 'VOIP',
  SYSTEM = 'SYSTEM',
  DATA = 'DATA',
  NETWORK = 'NETWORK',
  TROUBLESHOOT = 'TROUBLESHOOT',
}

export enum msbrPortMode {
  P2P = 'P2P',
  P2MP = 'P2MP',
}

export enum msbrPortType {
  PRI = 'PRI',
  BRI = 'BRI',
}

export enum NoAdminMode {
  TALK = 'TALK',
  WAIT = 'WAIT',
}

export enum PhoneNumberPhoneNumDir {
  IN = 'IN',
  OUT = 'OUT',
  IN_OUT = 'IN_OUT',
}

export enum PhoneNumberPhoneNumType {
  INTERNAL = 'INTERNAL',
  CORPORATE = 'CORPORATE',
  FIXED_NETWORK = 'FIXED_NETWORK',
  MSISDN = 'MSISDN',
}

export enum PlanType {
  AUTO_CREATED = 'AUTO_CREATED',
  PERMANENT = 'PERMANENT',
  RECURRING = 'RECURRING',
  SCHEDULED = 'SCHEDULED',
}

export enum PortedStatus {
  NOT_PORTED = 'NOT_PORTED',
  PORTED_INACTIVE = 'PORTED_INACTIVE',
  PORTED_ACTIVE = 'PORTED_ACTIVE',
}

export enum RoutingRuleAction {
  UNKNOWN = 'UNKNOWN',
  ALLOW = 'ALLOW',
  DENY = 'DENY',
  STATIC = 'STATIC',
  AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED',
  CONTACT = 'CONTACT',
  FORBIDDEN = 'FORBIDDEN',
  MAP_LOCAL = 'MAP_LOCAL',
  MAP_NATIONAL = 'MAP_NATIONAL',
  MAP_INTERNATIONAL = 'MAP_INTERNATIONAL',
  MAP_GATEWAY = 'MAP_GATEWAY',
  MAP_EMERGENCY_CALL = 'MAP_EMERGENCY_CALL',
  MOVED_TEMPORARILY = 'MOVED_TEMPORARILY',
  MOVED_PERMANENTLY = 'MOVED_PERMANENTLY',
  UNSUPPORTED_URI_SCHEME = 'UNSUPPORTED_URI_SCHEME',
  INCOMPLETE = 'INCOMPLETE',
  NORMALIZE_AND_LOCATE = 'NORMALIZE_AND_LOCATE',
  NORMALIZE = 'NORMALIZE',
  NORMALIZE_EXTERNAL = 'NORMALIZE_EXTERNAL',
}

export enum RoutingRuleRequery {
  UNKNOWN = 'UNKNOWN',
  YES = 'YES',
  NO = 'NO',
  CONTINUE = 'CONTINUE',
}

export enum SettingScope {
  GLOBAL = 'GLOBAL',
  SYSTEM = 'SYSTEM',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  ENTERPRISE = 'ENTERPRISE',
  SITE = 'SITE',
  LOCATION_GROUP = 'LOCATION_GROUP',
  USER = 'USER',
}

export enum SmppConfigSender {
  SERVICE = 'SERVICE',
  CALLING_PARTY = 'CALLING_PARTY',
  CONFIGURED_NUMBER = 'CONFIGURED_NUMBER',
}

export enum SmsMoMapSyncSyncAction {
  ADD = 'ADD',
  DELETE = 'DELETE',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SpecialTargetCallingPartyType {
  UNKNOWN = 'UNKNOWN',
  INTERNATIONAL = 'INTERNATIONAL',
  NATIONAL = 'NATIONAL',
  LOCAL = 'LOCAL',
}

export enum SpecialTargetEndPoint {
  NORMAL = 'NORMAL',
  SIP_TRUNK = 'SIP_TRUNK',
}

export enum SpecialTargetHoldFormat {
  SEND_ONLY = 'SEND_ONLY',
  INACTIVE = 'INACTIVE',
  SEND_RECV = 'SEND_RECV',
}

export enum SpecialTargetHostSubType {
  DEFAULT = 'DEFAULT',
  ISUP = 'ISUP',
}

export enum SpecialTargetHostType {
  GATEWAY = 'GATEWAY',
  MEDIA_SERVER = 'MEDIA_SERVER',
  APPLICATION_SERVER = 'APPLICATION_SERVER',
  LOCAL_BREAKOUT = 'LOCAL_BREAKOUT',
  CALL_RECORDING_SERVER = 'CALL_RECORDING_SERVER',
}

export enum SpecialTargetInviteBehaviour {
  SEND_SDP = 'SEND_SDP',
  NO_SDP = 'NO_SDP',
  X_TELES_HEADER = 'X_TELES_HEADER',
}

export enum SpecialTargetIsupManipulation {
  NONE = 'NONE',
  ADD_SPLIT_HEAD_NUMBER = 'ADD_SPLIT_HEAD_NUMBER',
  ADD_FULL_EXTENSION = 'ADD_FULL_EXTENSION',
}

export enum SpecialTargetOverlapMode {
  DISABLED = 'DISABLED',
  INFO = 'INFO',
  REINVITE = 'REINVITE',
}

export enum SpecialTargetPaiManipulation {
  NO_MODIFICATION = 'NO_MODIFICATION',
  INTERNATIONAL = 'INTERNATIONAL',
  E164 = 'E164',
  NONE = 'NONE',
  NATIONAL = 'NATIONAL',
}

export enum SpecialTargetPAssertedType {
  UNKNOWN = 'UNKNOWN',
  INTERNATIONAL = 'INTERNATIONAL',
  NATIONAL = 'NATIONAL',
  LOCAL = 'LOCAL',
}

export enum SpecialTargetPEarlyMediaType {
  NONE = 'NONE',
  SUPPORTED = 'SUPPORTED',
}

export enum SpecialTargetPrackMode {
  DISABLED = 'DISABLED',
  SUPPORTED = 'SUPPORTED',
  REQUIRED = 'REQUIRED',
}

export enum SpecialTargetReceiveRemotePartyFormat {
  EXTENSION = 'EXTENSION',
  E164_NUMBER = 'E164_NUMBER',
}

export enum SpecialTargetReceiveUserProvidedNum {
  FROM_USER = 'FROM_USER',
  FROM_DISPLAY = 'FROM_DISPLAY',
  P_PREFERRED_ID = 'P_PREFERRED_ID',
  REMOTE_PARTY_ID = 'REMOTE_PARTY_ID',
}

export enum SpecialTargetRequiredHeader {
  HISTORY_SYSTEM_DEFAULT = 'HISTORY_SYSTEM_DEFAULT',
  DIVERSION_SYSTEM_DEFAULT = 'DIVERSION_SYSTEM_DEFAULT',
  NONE = 'NONE',
  CALL_HISTORY_INFO = 'CALL_HISTORY_INFO',
  CALL_DIVERSION_INFO = 'CALL_DIVERSION_INFO',
}

export enum SpecialTargetSendRemotePartyInfo {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export enum SpecialTargetSpecialTargetStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DENY = 'DENY',
}

export enum SpecialTargetStrategy {
  RFC_2782 = 'RFC_2782',
  REDUNDANT = 'REDUNDANT',
  LOAD_BALANCING = 'LOAD_BALANCING',
  REDUNDANT_NAT = 'REDUNDANT_NAT',
  LOAD_BALANCING_NAT = 'LOAD_BALANCING_NAT',
  SINGLE_TARGET = 'SINGLE_TARGET',
}

export enum SpecialTargetEntryCapabilities {
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  VOICE_IVR = 'VOICE_IVR',
  VIDEO_IVR = 'VIDEO_IVR',
  VOICE_CONF = 'VOICE_CONF',
  VIDEO_CONF = 'VIDEO_CONF',
  FAX = 'FAX',
}

export enum SpecialTargetEntryProtocols {
  NETANN = 'NETANN',
  MSML = 'MSML',
  MSCML = 'MSCML',
}

export enum TimeTableVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export enum UmsMessageMessageFlag {
  UNKNOWN = 'UNKNOWN',
  NEW = 'NEW',
  SEEN = 'SEEN',
  DELETED = 'DELETED',
}

export enum UmsMessageMessageType {
  UNKNOWN = 'UNKNOWN',
  VOICE_MAIL = 'VOICE_MAIL',
  FAX_MAIL = 'FAX_MAIL',
  SMS = 'SMS',
  RECORDED_CALL = 'RECORDED_CALL',
}

export enum UserAuth {
  FULL = 'FULL',
  FORBID_DEVICE = 'FORBID_DEVICE',
  READ_ONLY = 'READ_ONLY',
  NON_REG_EXT_PBX = 'NON_REG_EXT_PBX',
  MOBILE_USER = 'MOBILE_USER',
  EXTERNAL_NUMBER = 'EXTERNAL_NUMBER',
}

export enum UserRole {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  SERVICE_PROVIDER_ADMIN = 'SERVICE_PROVIDER_ADMIN',
  ENTERPRISE_ADMIN = 'ENTERPRISE_ADMIN',
  SITE_ADMIN = 'SITE_ADMIN',
  END_USER = 'END_USER',
  MSN = 'MSN',
  LBO = 'LBO',
  BT = 'BT',
  AD_HOC_CONF = 'AD_HOC_CONF',
  DEDICATED_CONF = 'DEDICATED_CONF',
  IVR_ASSISTANT = 'IVR_ASSISTANT',
  VOICE_MAIL = 'VOICE_MAIL',
  CALL_RECORDING = 'CALL_RECORDING',
  MOBILE_CONTROL = 'MOBILE_CONTROL',
  ACD_QUEUE = 'ACD_QUEUE',
  CALL_CENTER = 'CALL_CENTER',
}

export enum UserState {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export enum UserPreferenceDomainSortCol {
  NAME = 'NAME',
  DESCRIPTION = 'DESCRIPTION',
  TYPE = 'TYPE',
}

export enum UserPreferenceDomainSortOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

export enum UserPreferenceFaxFormatType {
  PDF = 'PDF',
  TIFF = 'TIFF',
}

export enum UserPreferenceGatewaySortCol {
  NAME = 'NAME',
  DESCRIPTION = 'DESCRIPTION',
  SPECIAL_TARGET = 'SPECIAL_TARGET',
}

export enum UserPreferenceNotificationType {
  NONE = 'NONE',
  MAIL = 'MAIL',
  MAIL_WITH_ATTACHMENT = 'MAIL_WITH_ATTACHMENT',
}

export enum UserPreferenceScreenNumberSortCol {
  E164 = 'E164',
  TYPE = 'TYPE',
}

export enum UserPreferenceUserSortCol {
  LAST_NAME = 'LAST_NAME',
  FIRST_NAME = 'FIRST_NAME',
  LOGIN_NAME = 'LOGIN_NAME',
  ROLE = 'ROLE',
  BUSINESS_NUM = 'BUSINESS_NUM',
}

export enum WaitingType {
  MUSIC = 'MUSIC',
  SILENCE = 'SILENCE',
  VOICE = 'VOICE',
}

export enum Weekday {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}
